(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
var ForexBrokerSpreads = /*#__PURE__*/function () {
  function ForexBrokerSpreads(spreadsRoot) {
    _classCallCheck(this, ForexBrokerSpreads);
    this.spreadsRoot = spreadsRoot;
    this.urls = {
      GetBrokerSpreads: "/api/spreads/{id}",
      SpreadsUpdateHub: "/spreadsUpdateHub"
    };
    this.selectedSymbols = [];
    this.rawSpreads = {};
    this.standardSpreads = {};
    this.symbols = [];
    this.selectedSpread = "oneDayAverageSpread";
    this.brokerId = 0;
    this.isCommission = true;
    this.broker = {};
    this.tabName = "Spreads";
    this.accountType = 2;
    this.symbolId = 0;
    this.locale = "en-US";
    this.spreadTypes = [{
      name: "currentSpread",
      str: "Real-time",
      code: ""
    }, {
      name: "fourHourAverageSpread",
      str: "4 hour average",
      code: ""
    }, {
      name: "oneDayAverageSpread",
      str: "1 day average",
      code: ""
    }, {
      name: "oneWeekAverageSpread",
      str: "1 week average",
      code: ""
    }, {
      name: "",
      str: "",
      code: ""
    }, {
      name: "sydneySessionAverageSpread",
      str: "Sydney session",
      code: "AU"
    }, {
      name: "tokyoSessionAverageSpread",
      str: "Tokyo session",
      code: "JP"
    }, {
      name: "londonSessionAverageSpread",
      str: "London session",
      code: "GB"
    }, {
      name: "newyorkSessionAverageSpread",
      str: "New York session",
      code: "US"
    }];
    this.urlSlug = "forex-broker-spreads";
  }
  _createClass(ForexBrokerSpreads, [{
    key: "Url",
    value: function Url(key) {
      return this.spreadsRoot + this.urls[key];
    }
  }, {
    key: "InitializeBrokerSpread",
    value: function InitializeBrokerSpread(id, accountType, symbolName, tab) {
      var myThis = this;
      myThis.brokerId = id;
      $.ajax({
        url: myThis.Url('GetBrokerSpreads').replace("{id}", id),
        type: "GET",
        success: function success(res) {
          myThis.rawSpreads = res.find(function (x) {
            return x.accountType == 1;
          });
          myThis.standardSpreads = res.find(function (x) {
            return x.accountType == 0;
          });
          res[0].spreads.forEach(function (symbolSpread) {
            myThis.symbols.push(symbolSpread.symbol);
          });
          myThis.tabName = tab == "" ? "Spreads" : tab;
          $("#brokerSpreadsTab div").removeClass('frn-tab-active');
          switch (tab) {
            case "Spreads":
              $("#spreads-tab").addClass('frn-tab-active');
              break;
            case "Commissions":
              $("#commissions-tab").addClass('frn-tab-active');
              break;
            default:
              $("#spreads-tab").addClass('frn-tab-active');
          }
          myThis.selectedSymbols = myThis.symbols;
          myThis.broker = res[0].broker;
          if (myThis.broker.entityType == "ForexBroker") {
            myThis.urlSlug = "forex-broker-spreads";
          } else myThis.urlSlug = "prop-firm-spreads";
          myThis.accountType = accountType;
          if (symbolName == "") {
            myThis.symbolId = 0;
          } else {
            var symbol = myThis.symbols.find(function (x) {
              return x.name == symbolName;
            });
            myThis.symbolId = symbol.id;
          }
          if (accountType != 2 || myThis.symbolId != 0) {
            $("#brokerSpreadsTab").css('display', 'none');
          } else $("#brokerSpreadsTab").css('display', 'inline-flex');
          var title = "";
          var desc = "";
          if (tab == "") {
            if (symbolName == "") {
              if (accountType == 2) {
                title = myThis.broker.brokerName + " " + window.spreadsString["Spreads"];
                desc = window.spreadsString["BrokerDetailSpreadsDescription"].replace("{0}", myThis.broker.brokerName);
              } else {
                var type = accountType == 1 ? myThis.broker.chargedCommissionAccountType != null ? myThis.broker.chargedCommissionAccountType : "Raw" : myThis.broker.notChargedCommissionAccountType != null ? myThis.broker.notChargedCommissionAccountType : "Standard";
                var description = "";
                if (type != "Raw" && type != "Standard") {
                  description = window.spreadsString["BrokerSpreadsDescription"].replace("{0}", myThis.broker.brokerName).replace("{1}", type);
                } else description = window.spreadsString["Broker" + type + "SpreadsDescription"].replace("{0}", myThis.broker.brokerName);
                title = myThis.broker.brokerName + " " + type + " " + window.spreadsString["Spreads"];
                desc = description;
              }
            } else {
              $("#broker-spread-spread-select").css('display', 'none');
              $("#broker-spread-session-select").css('display', 'none');
              title = myThis.broker.brokerName + " " + symbolName + " " + window.spreadsString["Spreads"];
              desc = window.spreadsString["BrokerSymbolSpreadsDescription"].replace("{0}", myThis.broker.brokerName).replace("{1}", symbolName);
              if (myThis.broker.entityType == "ForexBroker") $('#symbol-spreads-link a').attr('href', '/tools/forex-broker-spreads/' + symbolName);else $('#symbol-spreads-link a').attr('href', '/tools/prop-firm-spreads/' + symbolName);
              $('#symbol-spreads-link a').html("View all " + symbolName + " spreads >");
              $('#symbol-spreads-link').show();
            }
          } else {
            if (tab == "Commissions") {
              $("#broker-spread-spread-select").css('display', 'none');
              $("#broker-spread-session-select").css('display', 'none');
              $("#commission-checkbox").css('display', 'none');
            }
            title = myThis.broker.brokerName + " " + window.spreadsString[tab];
            desc = window.spreadsString["BrokerDetail" + tab + "Description"].replace("{0}", myThis.broker.brokerName);
          }
          $("title").html(title);
          $("#broker-spread-name").html(title);
          $("#broker-spread-description").html(desc);
          myThis.UpdateChartBreadcrumb();
          if (window.CURRENT_LANG != "ar") myThis.locale = window.CURRENT_CULTURE;
          myThis.InitializeTable();
          InitializeScrollTable("#broker-spread-table");
          myThis.InitializeTableBody();
        },
        error: function error() {
          console.log("Error occured");
        }
      });
    }
  }, {
    key: "UpdateChartBreadcrumb",
    value: function UpdateChartBreadcrumb() {
      var myThis = this;
      var title = $("h1").text();
      var langSlug = "/";
      if (window.CURRENT_LANG != 'en') langSlug = "/" + window.CURRENT_LANG + "/";
      $("#site-breadcrumb>.breadcrumb-item:nth-child(4)").replaceWith('<a class="breadcrumb-item" href="' + langSlug + (myThis.broker.entityType == 'ForexBroker' ? 'tools/forex-broker-spreads/' : 'tools/prop-firm-spreads/') + myThis.broker.code + '">' + $("#site-breadcrumb>.breadcrumb-item:nth-child(4)").text() + '</a>');
      var lastItem = '<span class="breadcrumb-item">';
      lastItem += title;
      lastItem += '</span>';
      if ($("#site-breadcrumb>.breadcrumb-item:nth-child(5)").length > 0) {
        $("#site-breadcrumb>.breadcrumb-item:nth-child(5)").replaceWith(lastItem);
      } else {
        $("#site-breadcrumb").append(lastItem);
      }
      if ($('script[type="application/ld+json"]').length == 0) return;
      var breadcrumbSchema = JSON.parse($('script[type="application/ld+json"]').html());
      if (breadcrumbSchema['itemListElement'] && Array.isArray(breadcrumbSchema['itemListElement'])) {
        var items = breadcrumbSchema['itemListElement'];
        if (items.length == 4) {
          items.push({
            '@type': 'ListItem',
            position: 5,
            name: title,
            item: window.location.href
          });
        } else if (items.length > 4) {
          items[4] = {
            '@type': 'ListItem',
            position: 5,
            name: title,
            item: window.location.href
          };
        }
        breadcrumbSchema['name'] = title;
        breadcrumbSchema['numberOfItems'] = 5;
        $('script[type="application/ld+json"]').html(JSON.stringify(breadcrumbSchema));
      }
    }
  }, {
    key: "InitializeEventTriggers",
    value: function InitializeEventTriggers() {
      var myThis = this;
      $(window).on('popstate', function (e) {
        location.reload();
      });
      $(document).on('click', '#brokerSpreadsTab div', function (e) {
        $("#brokerSpreadsTab div").removeClass('frn-tab-active');
        e.currentTarget.classList.add('frn-tab-active');
        var tabName = e.currentTarget.id;
        var title = "";
        if (tabName == "spreads-tab") {
          title = myThis.broker.brokerName + " " + window.spreadsString["Spreads"];
          $("#broker-spread-name").html(myThis.broker.brokerName + " " + window.spreadsString["Spreads"]);
          $("#broker-spread-spread-select").css('display', 'block');
          $("#broker-spread-session-select").css('display', 'block');
          $("#commission-checkbox").css('display', 'block');
          myThis.tabName = "Spreads";
          history.pushState({}, "", "?tab=Spreads");
        } else if (tabName == "commissions-tab") {
          title = myThis.broker.brokerName + " " + window.spreadsString["Commissions"];
          $("#broker-spread-name").html(myThis.broker.brokerName + " " + window.spreadsString["Commissions"]);
          $("#broker-spread-spread-select").css('display', 'none');
          $("#broker-spread-session-select").css('display', 'none');
          $("#commission-checkbox").css('display', 'none');
          myThis.tabName = "Commissions";
          history.pushState({}, "", "?tab=Commissions");
        } else {
          title = myThis.broker.brokerName + " Overnight Fees (Swap Rates)";
          $("#broker-spread-name").html(myThis.broker.brokerName + " Overnight Fees (Swap Rates)");
          $("#broker-spread-spread-select").css('display', 'none');
          $("#broker-spread-session-select").css('display', 'none');
          $("#commission-checkbox").css('display', 'none');
          myThis.tabName = "Swap Rates";
          history.pushState({}, "", "?tab=SwapRates");
        }
        var queryString = window.location.search;
        var canonical = document.querySelector("link[rel='canonical']");
        if (canonical) {
          canonical.href = queryString;
        }
        $("title").html(title);
        $("#broker-spread-description").html(window.spreadsString["BrokerDetail" + myThis.tabName + "Description"].replace("{0}", myThis.broker.brokerName));
        myThis.UpdateChartBreadcrumb();
        myThis.InitializeTableBody();
      });
      $(document).on('change', 'input[name=query]', function (e) {
        myThis.selectedSymbols = [];
        myThis.symbols.forEach(function (b) {
          if (b.name.toLowerCase().includes(e.target.value.toLowerCase())) {
            myThis.selectedSymbols.push(b);
          }
        });
        if (e.target.value == "") {
          myThis.selectedSymbols = myThis.symbols;
        }
        myThis.InitializeTableBody();
      });
      $(document).on('change', 'select[name=time]', function (e) {
        var val = e.target.value;
        myThis.selectedSpread = val;
        myThis.InitializeTableBody();
      });
      $(document).on('change', 'select[name=session]', function (e) {
        var val = e.target.value;
        if (val == "noSession") {
          var timeVal = $("select[name=time]").val();
          myThis.selectedSpread = timeVal;
        } else myThis.selectedSpread = val;
        myThis.InitializeTableBody();
      });
      $(document).on('change', '#commission', function (e) {
        myThis.isCommission = e.target.checked;
        myThis.InitializeTableBody();
      });
      $(document).on('click', '#GoToRaw', function (e) {
        history.pushState({}, "", "?typ=1");
        var queryString = window.location.search;
        var canonical = document.querySelector("link[rel='canonical']");
        if (canonical) {
          canonical.href = queryString;
        }
        $('#meta-div').removeClass('bg-for-brokerspread');
        $('#brokerSpreadsTab').hide();
        $('#broker-spread-name').html(myThis.broker.brokerName + " " + (myThis.broker.chargedCommissionAccountType != null ? myThis.broker.chargedCommissionAccountType : "Raw") + " " + window.spreadsString["Spreads"]);
        $("title").html(myThis.broker.brokerName + " " + (myThis.broker.chargedCommissionAccountType != null ? myThis.broker.chargedCommissionAccountType : "Raw") + " " + window.spreadsString["Spreads"]);
        $('#broker-spread-spread-select').show();
        $('#broker-spread-session-select').show();
        $('#symbol-spreads-link').hide();
        var type = myThis.broker.chargedCommissionAccountType != null ? myThis.broker.chargedCommissionAccountType : "Raw";
        var description = "";
        if (type != "Raw") {
          description = window.spreadsString["BrokerSpreadsDescription"].replace("{0}", myThis.broker.brokerName).replace("{1}", type);
        } else description = window.spreadsString["BrokerRawSpreadsDescription"].replace("{0}", myThis.broker.brokerName);
        $("#broker-spread-description").html(description);
        myThis.accountType = 1;
        myThis.UpdateChartBreadcrumb();
        myThis.InitializeTable();
        myThis.InitializeTableBody();
      });
      $(document).on('click', '#GoToStandard', function (e) {
        history.pushState({}, "", "?typ=0");
        var queryString = window.location.search;
        var canonical = document.querySelector("link[rel='canonical']");
        if (canonical) {
          canonical.href = queryString;
        }
        $('#meta-div').removeClass('bg-for-brokerspread');
        $('#brokerSpreadsTab').hide();
        $('#broker-spread-name').html(myThis.broker.brokerName + " " + (myThis.broker.notChargedCommissionAccountType != null ? myThis.broker.notChargedCommissionAccountType : "Standard") + " " + window.spreadsString["Spreads"]);
        $("title").html(myThis.broker.brokerName + " " + (myThis.broker.notChargedCommissionAccountType != null ? myThis.broker.notChargedCommissionAccountType : "Standard") + " " + window.spreadsString["Spreads"]);
        $('#broker-spread-spread-select').show();
        $('#broker-spread-session-select').show();
        $('#symbol-spreads-link').hide();
        var type = myThis.broker.notChargedCommissionAccountType != null ? myThis.broker.notChargedCommissionAccountType : "Raw";
        var description = "";
        if (type != "Raw") {
          description = window.spreadsString["BrokerSpreadsDescription"].replace("{0}", myThis.broker.brokerName).replace("{1}", type);
        } else description = window.spreadsString["BrokerStandardSpreadsDescription"].replace("{0}", myThis.broker.brokerName);
        $("#broker-spread-description").html(description);
        myThis.accountType = 0;
        myThis.UpdateChartBreadcrumb();
        myThis.InitializeTable();
        myThis.InitializeTableBody();
      });
      $(document).on('click', '[id^="symbol-link"]', function (e) {
        var symbolId = e.target.id.substring(12);
        var symbolName = e.target.textContent;
        history.pushState({}, "", "?sym=" + symbolName);
        myThis.symbolId = symbolId;
        myThis.accountType = 2;
        $('#meta-div').removeClass('bg-for-brokerspread');
        $('#brokerSpreadsTab').hide();
        $('#broker-spread-name').html(myThis.broker.brokerName + " " + symbolName + " " + window.spreadsString["Spreads"]);
        $("title").html(myThis.broker.brokerName + " " + symbolName + " " + window.spreadsString["Spreads"]);
        $('#broker-spread-spread-select').hide();
        $('#broker-spread-session-select').hide();
        if (myThis.broker.entityType == "ForexBroker") $('#symbol-spreads-link a').attr('href', '/tools/forex-broker-spreads/' + symbolName);else $('#symbol-spreads-link a').attr('href', '/tools/prop-firm-spreads/' + symbolName);
        var canonical = document.querySelector("link[rel='canonical']");
        if (canonical) {
          canonical.href = canonical.href + "?sym=" + symbolName;
        }
        $('#symbol-spreads-link a').html("View all " + symbolName + " spreads >");
        $('#symbol-spreads-link').show();
        $("#broker-spread-description").html(window.spreadsString["BrokerSymbolSpreadsDescription"].replace("{0}", myThis.broker.brokerName).replace("{1}", symbolName));
        myThis.UpdateChartBreadcrumb();
        myThis.InitializeTable();
        myThis.InitializeTableBody();
      });
      var spreadsConnection = new signalR.HubConnectionBuilder().withUrl(myThis.Url('SpreadsUpdateHub')).configureLogging(signalR.LogLevel.Warning).withAutomaticReconnect().build();
      spreadsConnection.start();
      spreadsConnection.on("UpdateSpread", function (receivingSpreads) {
        myThis.rawSpreads = receivingSpreads.find(function (x) {
          return x.broker.cbfBrokerId == myThis.brokerId && x.accountType == 1;
        });
        myThis.standardSpreads = receivingSpreads.find(function (x) {
          return x.broker.cbfBrokerId == myThis.brokerId && x.accountType == 0;
        });
        myThis.InitializeTableBody();
      });
    }
  }, {
    key: "InitializeTable",
    value: function InitializeTable() {
      var myThis = this;
      var html = '<table class="row-border-table performances-table broker-spread-table fixed-column-table" id="broker-spread-table">';
      html += '<thead><tr>';
      if (myThis.accountType == 2) {
        if (myThis.symbolId == 0) {
          html += '<th>' + window.spreadsString["Symbol"] + '</th>';
          if (myThis.rawSpreads != undefined) html += "<th><a href='/tools/" + myThis.urlSlug + "/" + myThis.broker.code + "?typ=1' id='GoToRaw' onclick='return false;'>" + (myThis.broker.chargedCommissionAccountType != null ? window.spreadsString["SpreadAccount"].replace("{0}", myThis.broker.chargedCommissionAccountType) : window.spreadsString["RawSpreadAccount"]) + "</a></th>";
          if (myThis.standardSpreads != undefined) html += "<th style=\"padding: 0 9px 0 9px\"><a href='/tools/" + myThis.urlSlug + "/" + myThis.broker.code + "?typ=0' id='GoToStandard' onclick='return false;'>" + (myThis.broker.notChargedCommissionAccountType != null ? window.spreadsString["SpreadAccount"].replace("{0}", myThis.broker.notChargedCommissionAccountType) : window.spreadsString["StandardAccount"]) + "</a></th>";
        } else {
          html += "<th style=\"width: 45%\">" + window.spreadsString["Timeframe"] + "</th>";
          if (myThis.rawSpreads != undefined) html += "<th>" + (myThis.broker.chargedCommissionAccountType != null ? window.spreadsString["SpreadAccount"].replace("{0}", myThis.broker.chargedCommissionAccountType) : window.spreadsString["RawSpreadAccount"]) + "</th>";
          if (myThis.standardSpreads != undefined) html += "<th style=\"padding: 0 9px 0 9px\">" + (myThis.broker.notChargedCommissionAccountType != null ? window.spreadsString["SpreadAccount"].replace("{0}", myThis.broker.notChargedCommissionAccountType) : window.spreadsString["StandardAccount"]) + "</th>";
        }
      } else {
        html += "<th style=\"min-width: 100px;\" class=\"fixed-column\">" + window.spreadsString["Symbol"] + "</th>\n                    <th style=\"min-width: 100px;\">" + window.spreadsString["Spread"] + "</th>\n                    <th style=\"min-width: 100px;\">" + window.spreadsString["Commission"] + "</th>";
        //html += `<th style="min-width: 100px;">Swap Long</th>
        //        <th style="min-width: 100px;">Swap Short</th>
        //        <th style="min-width: 100px;">Swap Type</th>`;
      }

      html += '</thead></tr>';
      html += "<tbody id=\"broker-spread-table-body\"></tbody>";
      html += '</table>';
      $("#broker-spread-table-div").html(html);
    }
  }, {
    key: "InitializeTableBody",
    value: function InitializeTableBody() {
      var myThis = this;
      var html = '';
      if (myThis.symbolId == 0) {
        if (myThis.tabName == "Swap Rates" && myThis.accountType == 2) {
          $(".broker-spread-table thead tr th:not(:first-child)").attr('colspan', 5);
          $("#broker-spread-table-body").addClass("swap-rates-body");
          html += "<tr><td class='fixed-column'></td><td class='space-column'></td><td>Swap Long</td><td>Swap Short</td><td>Swap Type</td><td class='space-column'></td>";
          html += "<td class='space-column'></td><td>Swap Long</td><td>Swap Short</td><td>Swap Type</td><td class='space-column'></td></tr>";
        } else {
          $(".broker-spread-table thead tr th:not(:first-child)").attr('colspan', 1);
          $("#broker-spread-table-body").removeClass("swap-rates-body");
        }
        myThis.selectedSymbols.forEach(function (symbol) {
          var rawSpread = null;
          var rawSpreadVal = -1;
          var brokerId = 0;
          if (myThis.rawSpreads != undefined) {
            brokerId = myThis.rawSpreads.broker.cbfBrokerId;
            var sp = myThis.rawSpreads.spreads.find(function (x) {
              return x.symbol.name == symbol.name;
            });
            rawSpread = sp;
            rawSpreadVal = sp[myThis.selectedSpread];
          }
          var standardSpread = null;
          var standardSpreadVal = -1;
          if (myThis.standardSpreads != undefined) {
            brokerId = myThis.standardSpreads.broker.cbfBrokerId;
            var sp = myThis.standardSpreads.spreads.find(function (x) {
              return x.symbol.name == symbol.name;
            });
            standardSpread = sp;
            standardSpreadVal = sp[myThis.selectedSpread];
          }
          if (standardSpreadVal < 0 && rawSpreadVal < 0) return;
          if (myThis.accountType == 0 && standardSpreadVal < 0) return;
          if (myThis.accountType == 1 && rawSpreadVal < 0) return;
          html += "<tr>";
          html += "<td class=\"fixed-column\"><a href=\"/tools/" + myThis.urlSlug + "/" + myThis.broker.code + "?sym=" + symbol.name + "\"  id=\"symbol-link-" + symbol.id + "\" onclick=\"return false;\">" + symbol.name + "</a></td>";
          if (myThis.accountType == 2) {
            if (myThis.tabName != "Swap Rates") {
              if (rawSpreadVal < 0) {
                if (myThis.rawSpreads != undefined) html += "<td id=\"Broker" + brokerId + "-" + 1 + "Symbol" + symbol.id + "\">-</td>";
              } else {
                html += "<td id=\"Broker" + brokerId + "-" + 1 + "Symbol" + symbol.id + "\">";
                if (myThis.tabName == "Spreads") {
                  html += "<label class=\"" + (myThis.isCommission == true && rawSpread.commission > 0 ? "dotted-border-bottom" : "") + "\" data-toggle=\"tooltip\" data-html=\"true\" data-placement=\"bottom\" data-title=\"";
                  html += rawSpread.symbolType.includes("Forex") ? window.spreadsString["ExpressedInPips"] + "<br/>" : "";
                  html += myThis.isCommission == true && rawSpread.commission > 0 ? window.spreadsString["HasCommission"].replace("{0}", rawSpread.commissionUSD.toLocaleString(myThis.locale, {
                    maximumFractionDigits: 2
                  })) : window.spreadsString["NoCommission"];
                  html += "\" data-container=\"#broker-spread-table-body\">" + (myThis.isCommission == false ? rawSpreadVal.toLocaleString(myThis.locale, {
                    maximumFractionDigits: 2
                  }) : (rawSpreadVal + rawSpread.commission).toLocaleString(myThis.locale, {
                    maximumFractionDigits: 2
                  })) + "</label>";
                } else if (myThis.tabName == "Commissions") {
                  html += rawSpread.commissionUSD.toLocaleString(myThis.locale, {
                    maximumFractionDigits: 2
                  }) + " USD";
                }
                html += "</td>";
              }
              if (standardSpreadVal < 0) {
                if (myThis.standardSpreads != undefined) html += "<td id=\"Broker" + brokerId + "-" + 0 + "Symbol" + symbol.id + "\">-</td>";
              } else {
                html += "<td id=\"Broker" + brokerId + "-" + 0 + "Symbol" + symbol.id + "\">";
                if (myThis.tabName == "Spreads") {
                  html += "<label class=\"" + (myThis.isCommission == true && standardSpread.commission > 0 ? "dotted-border-bottom" : "") + "\" data-toggle=\"tooltip\" data-html=\"true\" data-placement=\"bottom\" data-title=\"";
                  html += standardSpread.symbolType.includes("Forex") ? window.spreadsString["ExpressedInPips"] + "<br/>" : "";
                  html += myThis.isCommission == true && standardSpread.commission > 0 ? window.spreadsString["HasCommission"].replace("{0}", standardSpread.commissionUSD.toLocaleString(myThis.locale, {
                    maximumFractionDigits: 2
                  })) : window.spreadsString["NoCommission"];
                  html += "\" data-container=\"#broker-spread-table-body\">" + (myThis.isCommission == false ? standardSpreadVal.toLocaleString(myThis.locale, {
                    maximumFractionDigits: 2
                  }) : (standardSpreadVal + standardSpread.commission).toLocaleString(myThis.locale, {
                    maximumFractionDigits: 2
                  })) + "</label>";
                } else if (myThis.tabName == "Commissions") {
                  html += "0";
                }
                html += "</td>";
              }
            } else {
              html += "<td class='space-column'></td><td>-</td><td>-</td><td>-</td><td class='space-column'></td>";
              html += "<td class='space-column'></td><td>-</td><td>-</td><td>-</td><td class='space-column'></td>";
            }
          } else {
            var spread = null;
            var spreadVal = -1;
            if (myThis.accountType == 0) {
              spread = standardSpread;
              spreadVal = standardSpreadVal;
            } else if (myThis.accountType == 1) {
              spread = rawSpread;
              spreadVal = rawSpreadVal;
            }
            if (spreadVal < 0) {
              html += "<td>-</td><td>-</td>";
              /*html += `<td>-</td><td>-</td><td>-</td>`;*/
            } else {
              html += "<td id=\"Broker" + brokerId + "-" + myThis.accountType + "Symbol" + symbol.id + "\">";
              html += "<label class=\"" + (myThis.isCommission == true && spread.commission > 0 ? "dotted-border-bottom" : "") + "\" data-toggle=\"tooltip\" data-html=\"true\" data-placement=\"bottom\" data-title=\"";
              html += spread.symbolType.includes("Forex") ? window.spreadsString["ExpressedInPips"] + "<br/>" : "";
              html += myThis.isCommission == true && spread.commission > 0 ? window.spreadsString["HasCommission"].replace("{0}", spread.commissionUSD.toLocaleString(myThis.locale, {
                maximumFractionDigits: 2
              })) : window.spreadsString["NoCommission"];
              html += "\" data-container=\"#broker-spread-table-body\">" + (myThis.isCommission == false ? spreadVal.toLocaleString(myThis.locale, {
                maximumFractionDigits: 2
              }) : (spreadVal + spread.commission).toLocaleString(myThis.locale, {
                maximumFractionDigits: 2
              })) + "</label>";
              html += "</td>";
              html += "<td>" + spread.commissionUSD.toLocaleString(myThis.locale, {
                maximumFractionDigits: 2
              }) + " USD</td>";
              /*html += `<td>-</td><td>-</td><td>-</td>`;*/
            }
          }

          html += "</tr>";
        });
      } else {
        var rawSpread = null;
        var brokerId = 0;
        if (myThis.rawSpreads != undefined) {
          brokerId = myThis.rawSpreads.broker.cbfBrokerId;
          var sp = myThis.rawSpreads.spreads.find(function (x) {
            return x.symbol.id == myThis.symbolId;
          });
          rawSpread = sp;
        }
        var standardSpread = null;
        if (myThis.standardSpreads != undefined) {
          brokerId = myThis.standardSpreads.broker.cbfBrokerId;
          var sp = myThis.standardSpreads.spreads.find(function (x) {
            return x.symbol.id == myThis.symbolId;
          });
          standardSpread = sp;
        }
        myThis.spreadTypes.forEach(function (type) {
          if (type.str == "" && type.name == "") {
            html += "<tr class=\"split-row\"><td></td><td></td><td></td></tr>";
          } else {
            html += "<tr>";
            html += '<td class="spread-type-td">';
            if (type.code != "") {
              html += "<span><i data-action=\"country\" data-country=\"" + type.code + "\" class=\"flag flag-" + type.code.toLowerCase() + "\" data-original-title=\"\" title=\"\"></i></span>";
            }
            html += type.str + '</td>';
            if (rawSpread == null) {
              if (myThis.rawSpreads != undefined) html += "<td id=\"Broker" + brokerId + "-" + 1 + "Symbol" + myThis.symbolId + type.name + "\">-</td>";
            } else {
              html += "<td id=\"Broker" + brokerId + "-" + 1 + "Symbol" + myThis.symbolId + type.name + "\">";
              html += "<label class=\"" + (myThis.isCommission == true && rawSpread.commission > 0 ? "dotted-border-bottom" : "") + "\" data-toggle=\"tooltip\" data-html=\"true\" data-placement=\"bottom\" data-title=\"";
              html += rawSpread.symbolType.includes("Forex") ? window.spreadsString["ExpressedInPips"] + "<br/>" : "";
              html += myThis.isCommission == true && rawSpread.commission > 0 ? window.spreadsString["HasCommission"].replace("{0}", rawSpread.commissionUSD.toLocaleString(myThis.locale, {
                maximumFractionDigits: 2
              })) : window.spreadsString["NoCommission"];
              html += "\" data-container=\"#broker-spread-table-body\">" + (myThis.isCommission == false ? rawSpread[type.name].toLocaleString(myThis.locale, {
                maximumFractionDigits: 2
              }) : (rawSpread[type.name] + rawSpread.commission).toLocaleString(myThis.locale, {
                maximumFractionDigits: 2
              })) + "</label>";
              html += "</td>";
            }
            if (standardSpread == null) {
              if (myThis.standardSpreads != undefined) html += "<td id=\"Broker" + brokerId + "-" + 0 + "Symbol" + myThis.symbolId + type.name + "\">-</td>";
            } else {
              html += "<td id=\"Broker" + brokerId + "-" + 0 + "Symbol" + myThis.symbolId + type.name + "\">";
              html += "<label class=\"" + (myThis.isCommission == true && standardSpread.commission > 0 ? "dotted-border-bottom" : "") + "\" data-toggle=\"tooltip\" data-html=\"true\" data-placement=\"bottom\" data-title=\"";
              html += standardSpread.symbolType.includes("Forex") ? window.spreadsString["ExpressedInPips"] + "<br/>" : "";
              html += myThis.isCommission == true && standardSpread.commission > 0 ? window.spreadsString["HasCommission"].replace("{0}", standardSpread.commissionUSD.toLocaleString(myThis.locale, {
                maximumFractionDigits: 2
              })) : window.spreadsString["NoCommission"];
              html += "\" data-container=\"#broker-spread-table-body\">" + (myThis.isCommission == false ? standardSpread[type.name].toLocaleString(myThis.locale, {
                maximumFractionDigits: 2
              }) : (standardSpread[type.name] + standardSpread.commission).toLocaleString(myThis.locale, {
                maximumFractionDigits: 2
              })) + "</label>";
              html += "</td>";
            }
            html += "</tr>";
          }
        });
      }
      InitializeScrollTable("#broker-spread-table");
      $('#broker-spread-table-body').html(html);
      $(".clone").remove();
      $(".fixed-header").remove();
      jQuery("#broker-spread-table").clone(true).appendTo('.tablescroll').addClass('clone');
      $('.tablescroll').append('<div class="fixed-header">');
      $('#broker-spread-table').clone(true).appendTo('.fixed-header').addClass('clone');
      $('.fixed-header').css('max-width', $('.tablescroll-wrap').width());
      $("#broker-spread-table-body [data-toggle=tooltip]").tooltip('dispose').tooltip({
        boundary: 'window'
      });
    }
  }]);
  return ForexBrokerSpreads;
}();
var _default = ForexBrokerSpreads;
exports["default"] = _default;

},{}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
var ForexSpreads = /*#__PURE__*/function () {
  function ForexSpreads(spreadsRoot, jwtToken, tableId) {
    _classCallCheck(this, ForexSpreads);
    this.jwtToken = jwtToken;
    this.spreadsRoot = spreadsRoot;
    this.tableId = tableId;
    this.urls = {
      InitialSpreads: "/api/initialspreads",
      GetBrokerSpreads: "/api/spreads/{id}",
      SpreadsUpdateHub: "/spreadsUpdateHub"
    };
    this.initialSymbolNames = ["EURUSD", "USDJPY", "GBPJPY", "EURGBP", "AUDNZD", "CADCHF", "BTCUSD", "ETHUSD", "XAUUSD", "XAGUSD"];
    this.initialSelectedSymbols = [{
      type: "Crypto",
      ids: [],
      className: "crypto-header",
      label: "Crypto"
    }, {
      type: "Forex",
      ids: [],
      className: "forex-header",
      label: "Forex"
    }, {
      type: "Index",
      ids: [],
      className: "index-header",
      label: "Indices"
    }, {
      type: "Commodity",
      ids: [],
      className: "commodity-header",
      label: "Commodities"
    }];
    this.selectedSymbols = [{
      type: "Crypto",
      ids: [],
      className: "crypto-header",
      label: "Crypto"
    }, {
      type: "Forex",
      ids: [],
      className: "forex-header",
      label: "Forex"
    }, {
      type: "Index",
      ids: [],
      className: "index-header",
      label: "Indices"
    }, {
      type: "Commodity",
      ids: [],
      className: "commodity-header",
      label: "Commodities"
    }];
    this.selectedBrokers = [];
    this.spreads = [];
    this.viewSpreads = [];
    this.symbols = [];
    this.brokers = {};
    this.rebateBrokers = [];
    this.premiumBrokers = [];
    this.superPremiumBrokers = [];
    this.selectedSpread = "oneDayAverageSpread";
    this.isCommission = true;
    this.sortedSymbol = {
      symbolId: -5,
      order: 1
    };
    this.scrollLeft = 0;
    this.scrollTop = 0;
    this.scrolling = false;
    this.topScrolling = false;
    this.entityType = "ForexBroker";
  }
  _createClass(ForexSpreads, [{
    key: "Url",
    value: function Url(key) {
      return this.spreadsRoot + this.urls[key];
    }
  }, {
    key: "ToLowerFirstLetter",
    value: function ToLowerFirstLetter(str) {
      if (!str) return str; // Handle empty or null strings
      return str.charAt(0).toLowerCase() + str.slice(1);
    }
  }, {
    key: "InitializePage",
    value: function InitializePage(entityType, contentUpdate) {
      var myThis = this;
      var symbolIds = [];
      myThis.selectedSymbols.forEach(function (typeSymbols) {
        symbolIds.push.apply(symbolIds, _toConsumableArray(typeSymbols.ids));
      });
      var brokerIds = [];
      brokerIds = myThis.selectedBrokers.map(function (x) {
        return x.CbfBrokerId;
      });
      $.ajax({
        url: myThis.Url('InitialSpreads'),
        data: {
          symbolIds: symbolIds,
          brokerIds: brokerIds,
          entityType: entityType
        },
        type: "GET",
        traditional: true,
        success: function success(res) {
          myThis.entityType = entityType;
          myThis.spreads = res;
          if (contentUpdate == 0) myThis.InitializeTable(contentUpdate);
          if ($('#spreads-table-body-' + myThis.tableId) && myThis.spreads.length > 0) {
            InitializeScrollTable("#spreads-table-" + myThis.tableId);
            myThis.GetViewSpreads(contentUpdate);
            if (contentUpdate == 1) {
              myThis.UpdateTableContent();
            } else {
              if (myThis.sortedSymbol["symbolId"] == -5 && contentUpdate == 0) {
                myThis.ShuffleArray(myThis.viewSpreads);
              } else if (myThis.sortedSymbol["symbolId"] != -5) {
                myThis.viewSpreads.sort(function (a, b) {
                  var compA = a.broker.brokerName;
                  var compB = b.broker.brokerName;
                  if (myThis.sortedSymbol["symbolId"] != 0) {
                    var aSpread = a.spreads.find(function (x) {
                      return x.symbol.id == myThis.sortedSymbol["symbolId"];
                    });
                    var bSpread = b.spreads.find(function (x) {
                      return x.symbol.id == myThis.sortedSymbol["symbolId"];
                    });
                    compA = aSpread[myThis.selectedSpread];
                    compB = bSpread[myThis.selectedSpread];
                    if (myThis.sortedSymbol["order"] == 1) {
                      if (compA < 0) compA = 10000000;
                      if (compB < 0) compB = 10000000;
                    }
                    if (myThis.isCommission == true) {
                      compA += aSpread.commission;
                      compB += bSpread.commission;
                    }
                  }
                  if (compA < compB) {
                    return -1 * myThis.sortedSymbol["order"];
                  }
                  if (compA > compB) {
                    return 1 * myThis.sortedSymbol["order"];
                  }
                  return 0;
                });
              }
              myThis.InitializeTableBody(myThis.viewSpreads);
              $("#spreads-table-" + myThis.tableId + ".clone").remove();
              $("#spreads-table-div-" + myThis.tableId + " .fixed-header").remove();
              $("#spreads-table-div-" + myThis.tableId + " .scroll-fixed-header").remove();
              jQuery("#spreads-table-" + myThis.tableId).clone(true).appendTo('#spreads-table-div-' + myThis.tableId + ' .tablescroll').addClass('clone');
              $('#spreads-table-div-' + myThis.tableId + ' .tablescroll').append('<div class="fixed-header">');
              $('#spreads-table-' + myThis.tableId).clone(true).appendTo('#spreads-table-div-' + myThis.tableId + ' .fixed-header').addClass('clone');
              $('#spreads-table-div-' + myThis.tableId + ' .fixed-header').css('max-width', $('#spreads-table-div-' + myThis.tableId + ' .tablescroll-wrap').width());
              $('#spreads-table-div-' + myThis.tableId + ' .tablescroll').append('<div class="scroll-fixed-header">');
              $('#spreads-table-' + myThis.tableId).clone(true).appendTo('#spreads-table-div-' + myThis.tableId + ' .scroll-fixed-header').addClass('clone');
              $('#spreads-table-div-' + myThis.tableId + ' .scroll-fixed-header').css('max-width', $('#spreads-table-div-' + myThis.tableId + ' .tablescroll-wrap').width());
              myThis.MakeFixedHeaderVisible();
            }
          }
        },
        error: function error() {
          console.log("Error occured");
        }
      });
    }
  }, {
    key: "InitializeEventTriggers",
    value: function InitializeEventTriggers(entityType) {
      var myThis = this;
      $(document).on('change', '#spreads-query-form-' + myThis.tableId + ' input[name=search]', function (e) {
        var val = $("#spreads-query-form-" + myThis.tableId + " select[name=brokertype").val();
        var bros = [];
        if (val == 0) bros = myThis.brokers;else bros = myThis.rebateBrokers;
        myThis.selectedBrokers = [];
        bros.forEach(function (b) {
          if (b.BrokerName.toLowerCase().includes(e.target.value.toLowerCase())) {
            myThis.selectedBrokers.push(b);
          }
        });
        if (e.target.value == "") {
          myThis.selectedBrokers = bros;
        }
        myThis.InitializeTable();
      });
      $(document).on('change', '#spreads-query-form-' + myThis.tableId + ' select[name=brokertype]', function (e) {
        var val = e.target.value;
        var bros = [];
        if (val == 0) bros = myThis.brokers;else bros = myThis.rebateBrokers;
        var inVal = $('#spreads-query-form-' + myThis.tableId + ' input[name=search]').val();
        if (inVal == "") {
          myThis.selectedBrokers = bros;
        } else {
          myThis.selectedBrokers = [];
          bros.forEach(function (b) {
            if (b.BrokerName.toLowerCase().includes(inVal.toLowerCase())) {
              myThis.selectedBrokers.push(b);
            }
          });
        }
        myThis.InitializeTable();
      });
      $(document).on('change', '#spreads-query-form-' + myThis.tableId + ' select[name=time]', function (e) {
        var val = e.target.value;
        myThis.selectedSpread = val;
        myThis.InitializeTable();
      });
      $(document).on('change', '#spreads-query-form-' + myThis.tableId + ' select[name=session]', function (e) {
        var val = e.target.value;
        if (val == "noSession") {
          var timeVal = $('#spreads-query-form-' + myThis.tableId + ' select[name=time]').val();
          myThis.selectedSpread = timeVal;
        } else myThis.selectedSpread = val;
        myThis.InitializeTable();
      });
      $(document).on('change', '#spreads-filter-dialog-' + myThis.tableId + ' #symbol-ul-' + myThis.tableId + ' li input[type=checkbox]', function (e) {
        if (e.target.checked == true) {
          var symbol = myThis.symbols.find(function (s) {
            return s.Name == e.target.name;
          });
          var typeSymbol = myThis.selectedSymbols.find(function (x) {
            return x.type == symbol.Type;
          });
          if (!typeSymbol.ids.includes(symbol.Id)) typeSymbol.ids.push(symbol.Id);
        } else {
          var symbol = myThis.symbols.find(function (s) {
            return s.Name == e.target.name;
          });
          var typeSymbols = myThis.selectedSymbols.find(function (x) {
            return x.type == symbol.Type;
          });
          typeSymbols.ids = typeSymbols.ids.filter(function (x) {
            return x != symbol.Id;
          });
        }
      });
      $(document).on('change', '#commission-' + myThis.tableId, function (e) {
        myThis.isCommission = e.target.checked;
        myThis.InitializeTable();
      });
      $(document).on('scroll', function (e) {
        myThis.MakeFixedHeaderVisible();
      });
      var spreadsConnection = new signalR.HubConnectionBuilder().withUrl(myThis.Url('SpreadsUpdateHub')).configureLogging(signalR.LogLevel.Warning).withAutomaticReconnect().build();
      spreadsConnection.start();
      spreadsConnection.on("UpdateSpread", function (receivingSpreads) {
        myThis.spreads = receivingSpreads.filter(function (x) {
          return x.broker.entityType == myThis.entityType;
        });
        myThis.GetViewSpreads(1);
        myThis.UpdateTableContent();
      });
    }
  }, {
    key: "GetViewSpreads",
    value: function GetViewSpreads(contentUpdate) {
      var myThis = this;
      if (contentUpdate == 0) myThis.viewSpreads = [];
      myThis.spreads.forEach(function (spread) {
        var tempSpread = {};
        tempSpread.accountType = spread.accountType;
        tempSpread.broker = spread.broker;
        tempSpread.spreads = [];
        myThis.selectedSymbols.forEach(function (typeSymbols, index) {
          typeSymbols.ids.forEach(function (tsymbol) {
            var symbolSpread = spread.spreads.find(function (x) {
              return x.symbol.id == tsymbol;
            });
            if (symbolSpread) tempSpread.spreads.push(symbolSpread);
          });
          var symbolType = typeSymbols.type;
          var tspreads = tempSpread.spreads.filter(function (sp) {
            return sp.symbolType == symbolType;
          });
          if (tspreads.length == 0) return;
          var typeSpreads = tempSpread.spreads.filter(function (sp) {
            return sp.symbolType == symbolType && sp.oneDayAverageSpread >= 0;
          });
          var tempSymbolSpread = {
            accountType: spread.spreads[0].accountType,
            commission: -1,
            commissionUSD: -1,
            currentSpread: -1,
            fourHourAverageSpread: -1,
            londonSessionAverageSpread: -1,
            newyorkSessionAverageSpread: -1,
            oneDayAverageSpread: -1,
            oneWeekAverageSpread: -1,
            sydneySessionAverageSpread: -1,
            tokyoSessionAverageSpread: -1,
            symbol: {
              id: -1 * (index + 1),
              name: symbolType + "Avg",
              description: "Average of " + symbolType + "s",
              type: symbolType + "Avg"
            },
            symbolType: symbolType + "Avg"
          };
          if (typeSpreads.length == tspreads.length) {
            tempSymbolSpread = {
              accountType: spread.spreads[0].accountType,
              commission: typeSpreads.reduce(function (total, next) {
                return total + next.commission;
              }, 0) / typeSpreads.length,
              commissionUSD: typeSpreads.reduce(function (total, next) {
                return total + next.commissionUSD;
              }, 0) / typeSpreads.length,
              currentSpread: typeSpreads.reduce(function (total, next) {
                return total + next.currentSpread;
              }, 0) / typeSpreads.length,
              fourHourAverageSpread: typeSpreads.reduce(function (total, next) {
                return total + next.fourHourAverageSpread;
              }, 0) / typeSpreads.length,
              londonSessionAverageSpread: typeSpreads.reduce(function (total, next) {
                return total + next.londonSessionAverageSpread;
              }, 0) / typeSpreads.length,
              newyorkSessionAverageSpread: typeSpreads.reduce(function (total, next) {
                return total + next.newyorkSessionAverageSpread;
              }, 0) / typeSpreads.length,
              oneDayAverageSpread: typeSpreads.reduce(function (total, next) {
                return total + next.oneDayAverageSpread;
              }, 0) / typeSpreads.length,
              oneWeekAverageSpread: typeSpreads.reduce(function (total, next) {
                return total + next.oneWeekAverageSpread;
              }, 0) / typeSpreads.length,
              sydneySessionAverageSpread: typeSpreads.reduce(function (total, next) {
                return total + next.sydneySessionAverageSpread;
              }, 0) / typeSpreads.length,
              tokyoSessionAverageSpread: typeSpreads.reduce(function (total, next) {
                return total + next.tokyoSessionAverageSpread;
              }, 0) / typeSpreads.length,
              symbol: {
                id: -1 * (index + 1),
                name: symbolType + "Avg",
                description: "Average of " + symbolType + "s",
                type: symbolType + "Avg"
              },
              symbolType: symbolType + "Avg"
            };
          }
          tempSpread.spreads.push(tempSymbolSpread);
        });
        if (contentUpdate == 0) myThis.viewSpreads.push(tempSpread);else {
          var vspid = myThis.viewSpreads.findIndex(function (vspread) {
            return vspread.broker.cbfBrokerId == tempSpread.broker.cbfBrokerId && vspread.accountType == tempSpread.accountType;
          });
          myThis.viewSpreads[vspid] = tempSpread;
        }
      });
    }
  }, {
    key: "ShuffleArray",
    value: function ShuffleArray(array) {
      var currentIndex = array.length,
        randomIndex;

      // While there remain elements to shuffle.
      while (currentIndex > 0) {
        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        // And swap it with the current element.
        var _ref = [array[randomIndex], array[currentIndex]];
        array[currentIndex] = _ref[0];
        array[randomIndex] = _ref[1];
      }
      return array;
    }
  }, {
    key: "InitializeTable",
    value: function InitializeTable() {
      var contentUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var dir = $('html').attr("dir");
      var myThis = this;
      var html = "<table class=\"row-border-table performances-table spreads-table fixed-column-table\" id=\"spreads-table-" + myThis.tableId + "\">";
      html += "<thead><tr class=\"font-13\"><th class=\"fixed-column\" rowspan=\"2\" onclick=\"SortBySymbolOfSpread(0, " + myThis.tableId + ")\">" + window.spreadsString["Brokers"] + (myThis.sortedSymbol["symbolId"] == 0 ? myThis.sortedSymbol["order"] == 1 ? "<img class=\"desc\" src=\"/Content/dist/images/icons/arrow-up-down-down-active.svg\"/>" : "<img class=\"asc\" src=\"/Content/dist/images/icons/arrow-up-down-up-active.svg\"/>" : "") + "</th>";
      myThis.selectedSymbols.forEach(function (typeSymbols, index) {
        if (typeSymbols.ids.length > 0) {
          html += "<th class=\"" + typeSymbols.className + " " + typeSymbols.type + (dir == "rtl" ? "Avg-border-left" : "Avg-border-right") + "\" colspan=\"" + (typeSymbols.ids.length + 1) + "\">" + window.spreadsString[typeSymbols.label] + "</th>";
        }
      });
      html += "</tr><tr class=\"font-13\">";
      myThis.selectedSymbols.forEach(function (typeSymbols, index) {
        typeSymbols.ids.forEach(function (tsymbol) {
          var symbol = myThis.symbols.find(function (x) {
            return x.Id == tsymbol;
          });
          html += "<th onclick=\"SortBySymbolOfSpread(" + symbol.Id + ", " + myThis.tableId + ")\" class=\"" + typeSymbols.className + " " + (symbol.Id == myThis.sortedSymbol["symbolId"] ? 'active' : '') + "\">" + symbol.Name + (symbol.Id == myThis.sortedSymbol["symbolId"] ? myThis.sortedSymbol["order"] == 1 ? "<img class=\"desc\" src=\"/Content/dist/images/icons/arrow-up-down-down-active.svg\"/>" : "<img class=\"asc\" src=\"/Content/dist/images/icons/arrow-up-down-up-active.svg\"/>" : "") + "</th>";
        });
        if (typeSymbols.ids.length > 0) html += "<th onclick=\"SortBySymbolOfSpread(" + -1 * (index + 1) + ", " + myThis.tableId + ")\" class=\"" + typeSymbols.className + " " + typeSymbols.type + (dir == "rtl" ? "Avg-border-left" : "Avg-border-right") + " " + (-1 * (index + 1) == myThis.sortedSymbol["symbolId"] ? 'active' : '') + "\">" + window.spreadsString["Average"] + (-1 * (index + 1) == myThis.sortedSymbol["symbolId"] ? myThis.sortedSymbol["order"] == 1 ? "<img class=\"desc\" src=\"/Content/dist/images/icons/arrow-up-down-down-active.svg\"/>" : "<img class=\"asc\" src=\"/Content/dist/images/icons/arrow-up-down-up-active.svg\"/>" : "") + "</th>";
      });
      html += "</tr></thead>";
      html += "<tbody id=\"spreads-table-body-" + myThis.tableId + "\">";
      html += "</tbody>";
      html += "</table>";
      $('#spreads-table-div-' + myThis.tableId).html(html);
      $('#spreads-table-loader-' + myThis.tableId).css('display', 'flex');
      if (myThis.spreads.length > 0) {
        myThis.GetViewSpreads(contentUpdate);
        if (myThis.sortedSymbol["symbolId"] == -5) {
          myThis.ShuffleArray(myThis.viewSpreads);
        } else {
          myThis.viewSpreads.sort(function (a, b) {
            var compA = a.broker.brokerName;
            var compB = b.broker.brokerName;
            if (myThis.sortedSymbol["symbolId"] != 0) {
              var aSpread = a.spreads.find(function (x) {
                return x.symbol.id == myThis.sortedSymbol["symbolId"];
              });
              var bSpread = b.spreads.find(function (x) {
                return x.symbol.id == myThis.sortedSymbol["symbolId"];
              });
              compA = aSpread[myThis.selectedSpread];
              compB = bSpread[myThis.selectedSpread];
              if (myThis.sortedSymbol["order"] == 1) {
                if (compA < 0) compA = 10000000;
                if (compB < 0) compB = 10000000;
              }
              if (myThis.isCommission == true) {
                compA += aSpread.commission;
                compB += bSpread.commission;
              }
            }
            if (compA < compB) {
              return -1 * myThis.sortedSymbol["order"];
            }
            if (compA > compB) {
              return 1 * myThis.sortedSymbol["order"];
            }
            return 0;
          });
        }
        InitializeScrollTable("#spreads-table-" + myThis.tableId);
        myThis.InitializeTableBody(myThis.viewSpreads);
        $("#spreads-table-" + myThis.tableId + ".clone").remove();
        $("#spreads-table-div-" + myThis.tableId + " .fixed-header").remove();
        $("#spreads-table-div-" + myThis.tableId + " .scroll-fixed-header").remove();
        jQuery("#spreads-table-" + myThis.tableId).clone(true).appendTo('#spreads-table-div-' + myThis.tableId + ' .tablescroll').addClass('clone');
        $('#spreads-table-div-' + myThis.tableId + ' .tablescroll').append('<div class="fixed-header">');
        $('#spreads-table-' + myThis.tableId).clone(true).appendTo('#spreads-table-div-' + myThis.tableId + ' .fixed-header').addClass('clone');
        $('#spreads-table-div-' + myThis.tableId + ' .fixed-header').css('max-width', $('#spreads-table-div-' + myThis.tableId + ' .tablescroll-wrap').width());
        $('#spreads-table-div-' + myThis.tableId + ' .tablescroll').append('<div class="scroll-fixed-header">');
        $('#spreads-table-' + myThis.tableId).clone(true).appendTo('#spreads-table-div-' + myThis.tableId + ' .scroll-fixed-header').addClass('clone');
        $('#spreads-table-div-' + myThis.tableId + ' .scroll-fixed-header').css('max-width', $('#spreads-table-div-' + myThis.tableId + ' .tablescroll-wrap').width());
        var dir = $("html").attr("dir");
        if (dir == "rtl" && screen.width < 425) {
          $('#spreads-table-div-' + myThis.tableId + ' .clone').css('right', $('#spreads-table-div-' + myThis.tableId + ' .clone').width() - $('#spreads-table-div-' + myThis.tableId + ' .tablescroll-wrap').width());
        }
        if (myThis.scrolling == true) {
          $('#spreads-table-div-' + myThis.tableId + ' .tablescroll-wrap').scrollLeft(myThis.scrollLeft);
          $('#spreads-table-div-' + myThis.tableId + ' .scroll-fixed-header').scrollLeft(myThis.scrollLeft);
          myThis.scrolling = false;
        }
        myThis.MakeFixedHeaderVisible();
      }
    }
  }, {
    key: "TableBodyContent",
    value: function TableBodyContent(brokerId, spreadInfo, className) {
      var dir = $("html").attr("dir");
      var langSlug = window.CURRENT_LANG == "en" ? "" : "/" + window.CURRENT_LANG;
      var myThis = this;
      var html = "";
      html += "<tr id='brokerspreads" + brokerId + "-" + spreadInfo.accountType + "' class='" + className + "'><td class=\"fixed-column\"><div class='flex'><img src='" + (spreadInfo.broker.logo != "" ? "/Content/dist/brokers/images/" + spreadInfo.broker.logo : '//image.thum.io/get/width/140/crop/1400/' + spreadInfo.broker.link) + "' /><div class='flex flex-column justify-content-center'><a href='" + langSlug + (myThis.entityType == 'ForexBroker' ? "/tools/forex-broker-spreads/" : "/tools/prop-firm-spreads/") + spreadInfo.broker.code + "' >" + spreadInfo.broker.brokerName + (spreadInfo.accountType == 0 ? spreadInfo.broker.notChargedCommissionAccountType != null ? " - " + spreadInfo.broker.notChargedCommissionAccountType : "" : spreadInfo.broker.chargedCommissionAccountType != null ? " - " + spreadInfo.broker.chargedCommissionAccountType : "") + "</a><label class='commission-label'>" + (spreadInfo.accountType == 0 ? window.spreadsString["CommissionFree"] : window.spreadsString["ChargingCommission"]) + "</label></div></div></td>";
      spreadInfo.spreads.forEach(function (symbolSpread) {
        var spread = symbolSpread[myThis.selectedSpread];
        var className = myThis.isCommission == true && symbolSpread.commission > 0 && spread >= 0 ? "dotted-border-bottom" : "";
        var tooltipStr = myThis.isCommission == true && symbolSpread.commission > 0 && spread >= 0 ? window.spreadsString["HasCommission"].replace("{0}", symbolSpread.commissionUSD.toFixed(2)) : window.spreadsString["NoCommission"];
        html += "<td id=\"Broker" + brokerId + "-" + spreadInfo.accountType + "Symbol" + symbolSpread.symbol.id + "\" class=\"" + (symbolSpread.symbolType.includes("Avg") ? symbolSpread.symbolType + (dir == "rtl" ? "-border-left" : "-border-right") : "") + "\">";
        html += "<label class=\"" + className + "\"data-toggle=\"tooltip\" data-html=\"true\" data-placement=\"bottom\" data-title=\"";
        html += symbolSpread.symbolType.includes("Forex") ? window.spreadsString["ExpressedInPips"] + "<br/>" : ""; /*+ (symbolSpread.symbol.standardPoint > 0 ? "(" + symbolSpread.symbol.standardPoint.toString().substring(1) + ")" : "")) */
        html += tooltipStr;
        html += "\" data-container=\"#spreads-table-div-" + myThis.tableId + "\">" + (spread < -1e-7 ? "-" : myThis.isCommission == false ? symbolSpread.symbol.name == "XAGUSD" ? spread.toFixed(3) : spread.toFixed(2) : symbolSpread.symbol.name == "XAGUSD" ? (spread + symbolSpread.commission).toFixed(3) : (spread + symbolSpread.commission).toFixed(2)) + "</label></td>";
      });
      html += "</tr>";
      return html;
    }
  }, {
    key: "InitializeTableBody",
    value: function InitializeTableBody(body) {
      var myThis = this;
      $('#spreads-table-loader-' + myThis.tableId).css('display', 'none');
      var html = '';
      body.forEach(function (spreadInfo) {
        var brokerId = spreadInfo.broker.cbfBrokerId;
        if (myThis.selectedBrokers.findIndex(function (x) {
          return x.CbfBrokerId == brokerId;
        }) >= 0 && myThis.superPremiumBrokers.findIndex(function (x) {
          return x.CbfBrokerId == brokerId;
        }) >= 0) {
          html += myThis.TableBodyContent(brokerId, spreadInfo, "superpremium");
        }
      });
      body.forEach(function (spreadInfo) {
        var brokerId = spreadInfo.broker.cbfBrokerId;
        if (myThis.selectedBrokers.findIndex(function (x) {
          return x.CbfBrokerId == brokerId;
        }) >= 0 && myThis.superPremiumBrokers.findIndex(function (x) {
          return x.CbfBrokerId == brokerId;
        }) < 0 && myThis.premiumBrokers.findIndex(function (x) {
          return x.CbfBrokerId == brokerId;
        }) >= 0) {
          html += myThis.TableBodyContent(brokerId, spreadInfo, "premium");
        }
      });
      body.forEach(function (spreadInfo) {
        var brokerId = spreadInfo.broker.cbfBrokerId;
        if (myThis.selectedBrokers.findIndex(function (x) {
          return x.CbfBrokerId == brokerId;
        }) >= 0 && myThis.superPremiumBrokers.findIndex(function (x) {
          return x.CbfBrokerId == brokerId;
        }) < 0 && myThis.premiumBrokers.findIndex(function (x) {
          return x.CbfBrokerId == brokerId;
        }) < 0) {
          html += myThis.TableBodyContent(brokerId, spreadInfo, "");
        }
      });
      $('#spreads-table-body-' + myThis.tableId).html(html);
      $('#spreads-table-div-' + myThis.tableId + ' [data-toggle=tooltip]').tooltip({
        boundary: 'window'
      });
      if (myThis.topScrolling == true) {
        $(document).scrollTop(myThis.scrollTop);
        myThis.topScrolling = false;
      }
    }
  }, {
    key: "UpdateTableContent",
    value: function UpdateTableContent() {
      var myThis = this;
      myThis.viewSpreads.forEach(function (viewSpread) {
        var brokerId = viewSpread.broker.cbfBrokerId;
        var accountType = viewSpread.accountType;
        viewSpread.spreads.forEach(function (symbolSpread) {
          var symbolId = symbolSpread.symbol.id;
          $("#Broker" + brokerId + "-" + accountType + "Symbol" + symbolId + " label").html(symbolSpread[myThis.selectedSpread] < -1e-7 ? "-" : myThis.isCommission == false ? symbolSpread.symbol.name == "XAGUSD" ? symbolSpread[myThis.selectedSpread].toFixed(3) : symbolSpread[myThis.selectedSpread].toFixed(2) : symbolSpread.symbol.name == "XAGUSD" ? (symbolSpread[myThis.selectedSpread] + symbolSpread.commission).toFixed(3) : (symbolSpread[myThis.selectedSpread] + symbolSpread.commission).toFixed(2));
        });
      });
    }
  }, {
    key: "ApplySpreadsFilter",
    value: function ApplySpreadsFilter(type) {
      var myThis = this;
      myThis.selectedBrokers = [];
      var brokers = $("#spreads-filter-dialog-" + myThis.tableId + " #broker-ul-" + myThis.tableId + " li input:checked");
      brokers.each(function (i, v) {
        var b = {};
        var brokerIdStr = v.id.split('-');
        var cbfBrokerId = brokerIdStr[1];
        b["CbfBrokerId"] = Number(cbfBrokerId);
        b["BrokerName"] = v.name;
        myThis.selectedBrokers.push(b);
      });
      if (type == 'tool') {
        var uncheckedBrokers = $("#spreads-filter-dialog-" + myThis.tableId + " #broker-ul-" + myThis.tableId + " li input:not(:checked)");
        if (uncheckedBrokers.length == 0) localStorage.setItem('selectedBrokers', 'All');else localStorage.setItem('selectedBrokers', JSON.stringify(myThis.selectedBrokers));
        localStorage.setItem('selectedSymbols', JSON.stringify(myThis.selectedSymbols));
      }
      myThis.InitializePage(myThis.entityType, 0);
      $('#spreads-filter-dialog-' + myThis.tableId).modal('hide');
    }
  }, {
    key: "MakeFixedHeaderVisible",
    value: function MakeFixedHeaderVisible() {
      var myThis = this;
      var scrollTop = $(document).scrollTop();
      if ($("#spreads-table-div-" + myThis.tableId + " .tablescroll-wrap").length > 0) {
        var stickyTop = $("#spreads-table-div-" + myThis.tableId + " .tablescroll-wrap").offset().top;
        var stickyBottom = $("#spreads-table-div-" + myThis.tableId + " .tablescroll-wrap").offset().top + $("#spreads-table-div-" + myThis.tableId + " .tablescroll-wrap").height();
        if (scrollTop > stickyTop + 42) {
          $("#spreads-table-div-" + myThis.tableId + " .fixed-header").css('display', 'block');
          $("#spreads-table-div-" + myThis.tableId + " .scroll-fixed-header").css('display', 'block');
          var topOffsetElement = document.getElementById('topmenu-logo');
          if (topOffsetElement !== null) {
            $("#spreads-table-div-" + myThis.tableId + " .fixed-header").css('top', topOffsetElement.offsetHeight);
            $("#spreads-table-div-" + myThis.tableId + " .scroll-fixed-header").css('top', topOffsetElement.offsetHeight);
          }
          $("#spreads-table-div-" + myThis.tableId + " .scroll-fixed-header table thead tr:first-child th:not(:first-child)").addClass('visible');
          $("#spreads-table-div-" + myThis.tableId + " .scroll-fixed-header table thead tr:not(:first-child) th").addClass('visible');
          $("#spreads-table-div-" + myThis.tableId + " .scroll-fixed-header").scrollLeft($("#spreads-table-div-" + myThis.tableId + " .tablescroll-wrap").scrollLeft());
        } else {
          $("#spreads-table-div-" + myThis.tableId + " .fixed-header").css('display', 'none');
          $("#spreads-table-div-" + myThis.tableId + " .scroll-fixed-header").css('display', 'none');
          $("#spreads-table-div-" + myThis.tableId + " .scroll-fixed-header table thead tr:first-child th:not(:first-child)").removeClass('visible');
          $("#spreads-table-div-" + myThis.tableId + " .scroll-fixed-header table thead tr:not(:first-child) th").removeClass('visible');
        }
        if (scrollTop > stickyBottom - 42) {
          $("#spreads-table-div-" + myThis.tableId + " .fixed-header").css('display', 'none');
          $("#spreads-table-div-" + myThis.tableId + " .scroll-fixed-header").css('display', 'none');
          $("#spreads-table-div-" + myThis.tableId + " .scroll-fixed-header table thead tr:first-child th:not(:first-child)").removeClass('visible');
          $("#spreads-table-div-" + myThis.tableId + " .scroll-fixed-header table thead tr:not(:first-child) th").removeClass('visible');
        }
      }
    }
  }]);
  return ForexSpreads;
}();
var _default = ForexSpreads;
exports["default"] = _default;

},{}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
var SymbolSpreads = /*#__PURE__*/function () {
  function SymbolSpreads(spreadsRoot, symbolId) {
    _classCallCheck(this, SymbolSpreads);
    this.spreadsRoot = spreadsRoot;
    this.urls = {
      InitialSpreads: "/api/initialspreads",
      SpreadsUpdateHub: "/spreadsUpdateHub"
    };
    this.spreads = [];
    this.brokers = [];
    this.selectedSpread = "oneDayAverageSpread";
    this.isCommission = true;
    this.selectedBrokers = [];
    this.symbolId = symbolId;
    this.urlSlug = "forex-broker-spreads";
    this.sort = -1;
  }
  _createClass(SymbolSpreads, [{
    key: "Url",
    value: function Url(key) {
      return this.spreadsRoot + this.urls[key];
    }
  }, {
    key: "InitializePage",
    value: function InitializePage(refresh) {
      var currentUrl = window.location.href;
      var entityType = "ForexBroker";
      var myThis = this;
      if (currentUrl.includes("forex-broker-spreads")) {
        entityType = "ForexBroker";
        myThis.urlSlug = "forex-broker-spreads";
      } else {
        entityType = "ProprietaryTradingFirm";
        myThis.urlSlug = "prop-firm-spreads";
      }
      window.APIHelper.SafeServiceAPICall({
        url: myThis.Url('InitialSpreads'),
        data: {
          symbolIds: [myThis.symbolId],
          brokerIds: [],
          entityType: entityType
        },
        traditional: true,
        type: "GET",
        success: function success(res) {
          myThis.spreads = res;
          res.forEach(function (spread) {
            myThis.brokers.push(spread.broker);
          });
          myThis.selectedBrokers = myThis.brokers;
          myThis.spreads.sort(function (a, b) {
            var spreadA = a.spreads.find(function (x) {
              return x.symbol.id == myThis.symbolId;
            });
            var spreadB = b.spreads.find(function (x) {
              return x.symbol.id == myThis.symbolId;
            });
            var compA = myThis.isCommission == false ? spreadA[myThis.selectedSpread] : spreadA[myThis.selectedSpread] + spreadA.commission;
            var compB = myThis.isCommission == false ? spreadB[myThis.selectedSpread] : spreadB[myThis.selectedSpread] + spreadB.commission;
            if (compA < compB) return 1 * myThis.sort;else if (compA > compB) return -1 * myThis.sort;
            return 0;
          });
          myThis.InitializeTableBody();
        },
        error: function error() {
          console.log("Error occured");
        }
      });
    }
  }, {
    key: "InitializeEventTriggers",
    value: function InitializeEventTriggers() {
      var myThis = this;
      $(document).on('change', 'input[name=search]', function (e) {
        var bros = myThis.brokers;
        myThis.selectedBrokers = [];
        bros.forEach(function (b) {
          if (b.BrokerName.toLowerCase().includes(e.target.value.toLowerCase())) {
            myThis.selectedBrokers.push(b);
          }
        });
        if (e.target.value == "") {
          myThis.selectedBrokers = bros;
        }
        myThis.InitializeTableBody();
      });
      $(document).on('change', 'select[name=time]', function (e) {
        var val = e.target.value;
        myThis.selectedSpread = val;
        myThis.InitializeTableBody();
      });
      $(document).on('change', 'select[name=session]', function (e) {
        var val = e.target.value;
        if (val == "noSession") {
          var timeVal = $("select[name=time]").val();
          myThis.selectedSpread = timeVal;
        } else myThis.selectedSpread = val;
        myThis.InitializeTableBody();
      });
      $(document).on('change', '#commission', function (e) {
        myThis.isCommission = e.target.checked;
        myThis.InitializeTableBody();
      });
      $(document).on('click', '#spreadTh', function (e) {
        if (e.target.classList.length == 1) {
          e.target.classList.add("asce");
          myThis.sort = -1;
        } else {
          e.target.classList.toggle("desc");
          e.target.classList.toggle("asce");
          if (e.target.classList.contains("desc")) myThis.sort = 1;else myThis.sort = -1;
        }
        myThis.spreads.sort(function (a, b) {
          var spreadA = a.spreads.find(function (x) {
            return x.symbol.id == myThis.symbolId;
          });
          var spreadB = b.spreads.find(function (x) {
            return x.symbol.id == myThis.symbolId;
          });
          var compA = myThis.isCommission == false ? spreadA[myThis.selectedSpread] : spreadA[myThis.selectedSpread] + spreadA.commission;
          var compB = myThis.isCommission == false ? spreadB[myThis.selectedSpread] : spreadB[myThis.selectedSpread] + spreadB.commission;
          if (compA < compB) return 1 * myThis.sort;else if (compA > compB) return -1 * myThis.sort;
          return 0;
        });
        myThis.InitializeTableBody();
      });
      var spreadsConnection = new signalR.HubConnectionBuilder().withUrl(myThis.Url('SpreadsUpdateHub')).configureLogging(signalR.LogLevel.Warning).withAutomaticReconnect().build();
      spreadsConnection.start();
      spreadsConnection.on("UpdateSpread", function (receivingSpreads) {
        myThis.spreads.forEach(function (spread) {
          var newSpread = receivingSpreads.find(function (x) {
            return x.broker.cbfBrokerId == spread.broker.cbfBrokerId;
          });
          newSpread.spreads = newSpread.spreads.filter(function (x) {
            return x.symbol.id == myThis.symbolId;
          });
          if (newSpread != null) {
            spread.spreads = newSpread.spreads;
          }
        });
        myThis.UpdateTableContent();
      });
    }
  }, {
    key: "InitializeTableBody",
    value: function InitializeTableBody() {
      $('#spreads-table-loader').css('display', 'none');
      var myThis = this;
      var html = '';
      myThis.spreads.sort(function (a, b) {
        var spreadA = a.spreads.find(function (x) {
          return x.symbol.id == myThis.symbolId;
        });
        var spreadB = b.spreads.find(function (x) {
          return x.symbol.id == myThis.symbolId;
        });
        var compA = myThis.isCommission == false ? spreadA[myThis.selectedSpread] : spreadA[myThis.selectedSpread] + spreadA.commission;
        var compB = myThis.isCommission == false ? spreadB[myThis.selectedSpread] : spreadB[myThis.selectedSpread] + spreadB.commission;
        if (compA < compB) return 1 * myThis.sort;else if (compA > compB) return -1 * myThis.sort;
        return 0;
      });
      myThis.spreads.forEach(function (spreadInfo) {
        var brokerId = spreadInfo.broker.cbfBrokerId;
        if (myThis.selectedBrokers.findIndex(function (x) {
          return x.cbfBrokerId == brokerId;
        }) >= 0) {
          var spread = spreadInfo.spreads.find(function (x) {
            return x.symbol.id == myThis.symbolId;
          });
          html += "<tr>";
          html += "<td><div class='flex' style='gap: 16px'><img src='" + (spreadInfo.broker.logo != "" ? "/Content/dist/brokers/images/" + spreadInfo.broker.logo : '//image.thum.io/get/width/140/crop/1400/' + spreadInfo.broker.link) + "' /><div class='flex flex-column justify-content-center'><a href='/tools/" + myThis.urlSlug + "/" + spreadInfo.broker.code + "' style='font-size: 12px'>" + spreadInfo.broker.brokerName + "</a>" + "<label class='commission-label'>" + (spreadInfo.accountType == 0 ? spreadInfo.broker.notChargedCommissionAccountType != null ? spreadInfo.broker.notChargedCommissionAccountType : "" : spreadInfo.broker.chargedCommissionAccountType != null ? spreadInfo.broker.chargedCommissionAccountType : "") + "</label></div></div></td>";
          html += "<td id=\"Broker" + brokerId + "-" + spreadInfo.accountType + "Symbol" + myThis.symbolId + "\">";
          html += "<label class=\"" + (myThis.isCommission == true && spread.commission > 0 ? "dotted-border-bottom" : "") + "\" data-toggle=\"tooltip\" data-html=\"true\" data-placement=\"bottom\" data-title=\"";
          html += spread.symbolType.includes("Forex") ? window.spreadsString["ExpressedInPips"] + "<br/>" : "";
          html += myThis.isCommission == true && spread.commission > 0 ? window.spreadsString["HasCommission"].replace("{0}", spread.commissionUSD.toFixed(2)) : window.spreadsString["NoCommission"];
          html += "\" data-container=\"#symbol-spread-table-body\">" + (myThis.isCommission == false ? spread[myThis.selectedSpread].toFixed(2) : (spread[myThis.selectedSpread] + spread.commission).toFixed(2)) + "</label>";
          html += "</td>";
          html += "</tr>";
        }
      });
      $('#symbol-spread-table-body').html(html);
      $("#spreads-table-div [data-toggle=tooltip]").tooltip('dispose').tooltip({
        boundary: 'window'
      });
    }
  }, {
    key: "UpdateTableContent",
    value: function UpdateTableContent() {
      var myThis = this;
      myThis.spreads.forEach(function (spreadInfo) {
        var brokerId = spreadInfo.broker.cbfBrokerId;
        var accountType = spreadInfo.accountType;
        spreadInfo.spreads.forEach(function (symbolSpread) {
          var symbolId = symbolSpread.symbol.id;
          $("#Broker" + brokerId + "-" + accountType + "Symbol" + symbolId + " label").html(symbolSpread[myThis.selectedSpread] < -1e-7 ? "-" : myThis.isCommission == false ? symbolSpread.symbol.name == "XAGUSD" ? symbolSpread[myThis.selectedSpread].toFixed(3) : symbolSpread[myThis.selectedSpread].toFixed(2) : symbolSpread.symbol.name == "XAGUSD" ? (symbolSpread[myThis.selectedSpread] + symbolSpread.commission).toFixed(3) : (symbolSpread[myThis.selectedSpread] + symbolSpread.commission).toFixed(2));
        });
      });
    }
  }]);
  return SymbolSpreads;
}();
var _default = SymbolSpreads;
exports["default"] = _default;

},{}],4:[function(require,module,exports){
'use strict';

var _ForexSpreads = _interopRequireDefault(require("../../includes/ForexSpreads.js"));
var _ForexBrokerSpreads = _interopRequireDefault(require("../../includes/ForexBrokerSpreads.js"));
var _SymbolSpreads = _interopRequireDefault(require("../../includes/SymbolSpreads.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
window.ForexSpreads = _ForexSpreads["default"];
window.ForexBrokerSpreads = _ForexBrokerSpreads["default"];
window.SymbolSpreads = _SymbolSpreads["default"];

},{"../../includes/ForexBrokerSpreads.js":1,"../../includes/ForexSpreads.js":2,"../../includes/SymbolSpreads.js":3}]},{},[4]);
